export const   fetchingFeaturedListings= 'FETCHING_HOT-CONTENT'
export const   fetchedFeaturedListings= 'FETCHED_HOT-CONTENT'
export const   errorFeaturedListings= 'ERROR-FETCHING-HOT-CONTENT'
